var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { Toggle, Triangle, useLang } from '@shapeable/ui';
import { classNames } from '@shapeable/utils';
var cls = classNames('personalised-menu-reveal');
export var PersonalisedMenuRevealDefaultProps = {
  isOn: false,
  onLabel: 'Menu'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n  "], ["\n    position: relative;\n  "])))
});
var TitleAndIconStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    ", "\n  "])), function (_a) {
    var isActive = _a.isActive;
    return isActive && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      cursor: pointer;\n      &:hover {\n        filter: brightness(1.1);\n      }\n    "], ["\n      cursor: pointer;\n      &:hover {\n        filter: brightness(1.1);\n      }\n    "])));
  })
});
var TriangleStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n   \n  "], ["\n   \n  "])))
});
var OnLabelStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: 500;\n    text-transform: uppercase;\n    color: ", ";\n\n    ", "\n\n    \n  "], ["\n    font-size: ", ";\n    font-weight: 500;\n    text-transform: uppercase;\n    color: ", ";\n\n    ", "\n\n    \n  "])), theme.FONT_SIZE(14), theme.COLOR('primary'), function (_a) {
    var isActive = _a.isActive;
    return !isActive && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.COLOR('text-subtle'));
  })
});
var MenuStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    position: absolute;\n    top: 30px;\n    left: 0;\n    z-index: 10;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(-20px);\n    transition: opacity 0.3s ease, transform 0.3s ease, visibility 0s linear 0.3s;\n\n    ", "\n  "], ["\n    position: absolute;\n    top: 30px;\n    left: 0;\n    z-index: 10;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(-20px);\n    transition: opacity 0.3s ease, transform 0.3s ease, visibility 0s linear 0.3s;\n\n    ", "\n  "])), function (_a) {
    var isOpen = _a.isOpen;
    return isOpen && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      opacity: 1;\n      visibility: visible;\n      transform: translateY(0);\n      transition: opacity 0.3s ease, transform 0.3s ease;\n    "], ["\n      opacity: 1;\n      visibility: visible;\n      transform: translateY(0);\n      transition: opacity 0.3s ease, transform 0.3s ease;\n    "])));
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    width: 240px;\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    background-color: ", ";\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    border-radius: 8px;\n  "], ["\n    width: 240px;\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    background-color: ", ";\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    border-radius: 8px;\n  "])), theme.COLOR('light'))
});
var TitleStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: 500;\n  "], ["\n    color: ", ";\n    font-size: ", ";\n    font-weight: 500;\n  "])), theme.COLOR('dark'), theme.FONT_SIZE(15))
});
var TogglesTitleStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: 500;\n  "], ["\n    color: ", ";\n    font-size: ", ";\n    font-weight: 500;\n  "])), theme.COLOR('dark'), theme.FONT_SIZE(12))
});
var ContentStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 12px;\n    font-weight: 300;\n    line-height: 160%; \n  "], ["\n    color: ", ";\n    font-size: 12px;\n    font-weight: 300;\n    line-height: 160%; \n  "])), theme.COLOR('text'))
});
var ToggleStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  TitleAndIcon: styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), TitleAndIconStyles),
  OnLabel: styled.span(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), OnLabelStyles),
  Triangle: styled(Triangle)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), TriangleStyles),
  Menu: styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), MenuStyles),
  Body: styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Title: styled.span(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Content: styled.span(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  TogglesTitle: styled.span(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), TogglesTitleStyles),
  OrgToggle: styled(Toggle)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ToggleStyles),
  ProfileToggle: styled(Toggle)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ToggleStyles),
  CountryToggle: styled(Toggle)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ToggleStyles)
};
export var PersonalisedMenuReveal = function (props) {
  var className = props.className,
    onLabel = props.onLabel,
    isOn = props.isOn;
  var _a = __read(React.useState(false), 2),
    isMenuOpen = _a[0],
    setIsMenuOpen = _a[1];
  var _b = __read(React.useState({
      org: false,
      profile: false,
      country: false
    }), 2),
    toggleStates = _b[0],
    setToggleStates = _b[1];
  var handleToggle = function (toggleKey) {
    setToggleStates(function (prevState) {
      var _a;
      return __assign(__assign({}, prevState), (_a = {}, _a[toggleKey] = !prevState[toggleKey], _a));
    });
  };
  var handleMenuToggle = function () {
    setIsMenuOpen(!isMenuOpen);
  };
  var t = useLang();
  var description = 'NavigatorGPT will use your profile’s information and context to generate a personalized response based on your:';
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.TitleAndIcon, {
    onClick: handleMenuToggle,
    isActive: isOn
  }, React.createElement(My.OnLabel, {
    isActive: isOn
  }, onLabel, isOn ? ' ON' : ' OFF'), React.createElement(My.Triangle, {
    color: isOn ? 'primary' : 'text-subtle',
    direction: 'down',
    size: 6,
    isActive: isOn
  })), isOn && React.createElement(My.Menu, {
    isOpen: isMenuOpen
  }, React.createElement(My.Body, null, React.createElement(My.Title, null, t('Personalized Results')), React.createElement(My.Content, null, description), React.createElement(My.TogglesTitle, null, t('Use the following information:')), React.createElement(My.OrgToggle, {
    onClick: function () {
      return handleToggle('org');
    },
    onLabel: t('Organization Type'),
    isOffColor: 'text',
    isOnColor: 'primary',
    isOn: toggleStates.org
  }), React.createElement(My.ProfileToggle, {
    onClick: function () {
      return handleToggle('profile');
    },
    onLabel: t('Profile description'),
    isOffColor: 'text',
    isOnColor: 'primary',
    isOn: toggleStates.profile
  }), React.createElement(My.CountryToggle, {
    onClick: function () {
      return handleToggle('country');
    },
    onLabel: t('Country'),
    isOffColor: 'text',
    isOnColor: 'primary',
    isOn: toggleStates.country
  }))));
};
PersonalisedMenuReveal.cls = cls;
PersonalisedMenuReveal.defaultProps = PersonalisedMenuRevealDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25;